
export default function ProblemsSection() {
  const problems = [
    {
      icon: 'ri-question-line',
      title: 'DXを進めたいが、何から始めればいいか分からない',
    },
    {
      icon: 'ri-team-line',
      title: '社内にITに詳しい人材がおらず、判断できない',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'SNSやECモールをもっと上手く活用したい',
    },
    {
      icon: 'ri-file-list-line',
      title: '運用代行に頼んでいるが、成果が不明',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '費用対効果が見えず、投資判断ができない',
    },
    {
      icon: 'ri-user-search-line',
      title: '若手人材の採用に苦戦している',
    },
  ];

  return (
    <section className="py-16 sm:py-24 md:py-32 bg-[#f8f9fa]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#333333] mb-4 tracking-wide">
              こんなお悩みはありませんか?
            </h2>
          </div>

          <div className="bg-white border border-gray-200 p-4 sm:p-6 md:p-8 space-y-4">
            <div className="space-y-3 text-left">
              {problems.map((problem, index) => (
                <div key={index} className="flex items-start gap-2.5">
                  <span className="text-[#27ae60] mt-0.5 flex-shrink-0 text-sm">✓</span>
                  <p className="text-[0.75rem] sm:text-sm md:text-base text-[#333333] leading-[1.8]">{problem.title}</p>
                </div>
              ))}
            </div>

            <div className="pt-6 mt-6 border-t border-gray-200">
              <div className="bg-[#f0f7f4] border-l-4 border-[#27ae60] px-4 sm:px-6 py-4 sm:py-5">
                <p className="text-[0.9rem] sm:text-base md:text-lg text-[#333333] font-bold leading-[1.8]">
                  → Naturiは<strong>「経営の右腕」</strong>として、戦略立案から実行、成果改善まで伴走します
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
